import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DocumentoPreEditado } from '../../_models';
import { DateAdapter } from '@angular/material/core';


@Component({
  selector: 'app-confirmacaoProtocolo',
  templateUrl: './confirmacaoProtocolo.component.html',
  styleUrls: ['./confirmacaoProtocolo.component.css']
})
export class ConfirmacaoProtocoloComponent implements OnInit {

  constructor(
    private dialogRef: MatDialogRef<ConfirmacaoProtocoloComponent>,
    private dateAdapter: DateAdapter<Date>,
    @Inject(MAT_DIALOG_DATA) public data: DocumentoPreEditado) { 
      this.dateAdapter.setLocale('pt-br');
      this.dateAdapter.parse = this.myParse;
    }

  ngOnInit() {
  }

  myParse(value: any): Date | null {
    if ((typeof value === 'string') && (value.indexOf('/') > -1)) {
      const str = value.split('/');
      return new Date(Number(str[2]), Number(str[1]) - 1, Number(str[0]), 12);
    }
    const timestamp = typeof value === 'number' ? value : Date.parse(value);
    return isNaN(timestamp) ? null : new Date(timestamp);
  }

  confirm(){
    this.dialogRef.close(true);
  }

  closePopup(){
    this.dialogRef.close(false);
  }

}
